<template>
  <force-landscape v-if="visible" :need-force-landscape="needForceLandscape">
    <div class="mask" :style="{ height: curHeight + 'px' }"></div>
    <div class="font1">
      <div
        style="text-align: center; margin-top: 6%"
        :style="{ height: curHeight + 'px' }"
      >
        <div
          style="
            display: flex;
            justify-content: center;
            align-items: center;
            margin-bottom: 2vmin;
          "
        ></div>

        <!-- <img :src="imgSrc" id="test" style="width: 63%; height: 100%; display: inline-block" /> -->
        <div class="bg">
          <div class="startButton" @click="startCountdown()">
            <div style="font-size: 5vmin; font-weight: bold">
              {{ buttonText }}
            </div>
          </div>
          <div class="title">{{ title }}</div>

          <div class="content-txt" v-html="stageConfig.content"></div>
        </div>

        <!-- 隐私协议 -->
        <div class="policy-txt">
          <div>
            Participando do [Competição Desafio Mar de Tropas], você reconhece e
            entende que suas informações pessoais serão processadas de acordo
            com a
            <span
              style="color: #5db1d9"
              @click="
                jumpToPolicy(
                  'https://www.honorofkings.com/br/policy/privacy.html'
                )
              "
              >Política de Privacidade</span
            >.
          </div>
        </div>
      </div>
    </div>
  </force-landscape>
</template>
<script>
import ForceLandscape from "../../../components/layout/ForceLandscape.vue";

export default {
  components: {
    ForceLandscape,
  },

  data() {
    return {
      title: "",
      buttonText: "",
      visible: false,
      needForceLandscape: false,
      url: "",
      type: 1, // 1残局 2兵海挑战
      timecount: -1,
      timer: [],
      stageConfig: {},
      curHeight: Math.min(window.innerHeight, window.innerWidth),
    };
  },

  mounted() {
    console.log(this.visible);
    window.addEventListener("resize", this.handleWindowChange);
  },

  methods: {
    getMessage(value) {
      console.log(value);
    },

    exitgame() {
      this.visible = false;
    },

    startCountdown() {
      if (!window.cg.game.isFullscreen()) {
        window.cg.game.fullscreen();
      }
      // this.timecount = 3;
      // this.timer[0] = setInterval(this.countDown, 1000);
      this.startgame();
    },

    countDown() {
      if (this.timecount > 1) {
        this.timecount -= 1;
      } else {
        this.visible = false;
        this.timecount = -1;
        this.startgame();
      }
    },

    startgame() {
      clearInterval(this.timer[0]);
      this.visible = false;
    },
    jumpToPolicy(url) {
      this.$defaultIframe.open({
        needForceLandscape: true,
        url: url,
      });
    },
    handleWindowChange() {
      this.curHeight = Math.min(window.innerHeight, window.innerWidth);

      console.log("innerHeight", this.curHeight);
    },
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleWindowChange);
  },
};
</script>
<style lang="less" scoped>
.mask {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-image: url("../../../assets/hok/start-bg.png");
  background-size: cover;
  overflow: hidden;
}
.font1 {
  font-family: "Radikal Medium";
  height: 100%;
}
.title {
  font-size: 20px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0px;
  color: #065fd5;
  display: inline-block;
  margin-top: 8vmin;
}

.bg {
  position: relative;
  background-image: url("../../../assets/hok/content-bg.png");
  background-size: 100% 100%;
  width: 50vmax;
  height: 80vmin;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  margin-left: 40vmax;
  .content-txt {
    width: 80%;
    font-size: 4vmin;
    margin-top: 5vmin;
    line-height: 6vmin;
  }
}

.startButton {
  // width: 45vmin;
  padding: 1vmin 6vmin;
  background: linear-gradient(to right, #e9a037, #fbbd05, #e9a037);
  box-shadow: 3px 3px 3px rgba(0, 0, 0, 0.4);
  height: 10vmin;
  color: #ffffff;
  border-radius: 2vmin;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 5vmin;
}
.timetext {
  font-size: 24vmin;
  color: rgb(255, 241, 195);
  margin-top: 20vmin;
}

.hint-wrap {
  font-size: 4vmin;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  width: 80%;
}

.hint-item {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
}
.policy-txt {
  font-size: 2vmin;
  font-weight: lighter;
  color: #ffffff;
  position: relative;
}
</style>
